module.exports = __webpack_public_path__ + "img/upside-down-face.f2e3cdf0.png";